var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFund1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9527_16311",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 49,
    height: 48
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28,
    r: 24,
    fill: "#E5FAFA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9527_16311)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 28,
    width: 50.4,
    height: 27,
    fill: "#E4E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.34375,
    y: 25.5996,
    width: 50.4,
    height: 2.4,
    transform: "rotate(25.7927 4.34375 25.5996)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 1.59961,
    width: 50.4,
    height: 27,
    fill: "#FF4F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8281 31.7445C28.2203 31.8916 28.5799 32.1204 28.8904 32.4309C30.7699 34.294 33.8422 35.4216 36.2119 35.7321C39.0883 36.0917 40.8369 34.5228 41.0167 32.0877C41.0167 31.9243 41.2292 31.8262 41.4743 31.8916L41.5723 26.4168L30.0998 25.9102C29.8056 27.2666 29.1519 29.6036 27.8281 31.7445Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0839 -35.4902L35.8379 -11.777L30.1016 25.9093L41.5741 26.4159C41.5741 26.4159 53.5533 0.954002 50.3175 -10.2734L62.5418 -28.9858C62.5418 -28.9858 40.9858 -34.575 41.0839 -35.4739V-35.4902Z",
    fill: "#F7B1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.018 32.0876C40.8383 34.5063 39.0896 36.0916 36.2133 35.732C33.8436 35.4379 30.7712 34.3102 28.8918 32.4308C28.5813 32.1203 28.2217 31.8915 27.8295 31.7444C27.1921 31.4993 26.4567 31.4993 25.7866 31.7444C22.1422 33.0518 18.0892 32.8884 14.2487 34.3756C11.7646 35.3398 11.6992 39.9811 11.6992 39.9811L44.3846 40.2263C44.0741 36.6309 42.7994 34.0324 42.1947 32.6106C41.9986 32.1366 41.7208 31.9405 41.492 31.8751C41.2469 31.8098 41.0344 31.9242 41.0344 32.0713L41.018 32.0876ZM41.9006 37.1375C41.9006 37.7585 41.3939 38.2815 40.7565 38.2815C40.1192 38.2815 39.6126 37.7749 39.6126 37.1375C39.6126 36.5001 40.1192 35.9935 40.7565 35.9935C41.3939 35.9935 41.9006 36.5001 41.9006 37.1375Z",
    fill: "#00CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7553 38.2802C41.3871 38.2802 41.8993 37.768 41.8993 37.1362C41.8993 36.5044 41.3871 35.9922 40.7553 35.9922C40.1235 35.9922 39.6113 36.5044 39.6113 37.1362C39.6113 37.768 40.1235 38.2802 40.7553 38.2802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.291 39.5343C11.2947 39.0511 11.6895 38.6623 12.1727 38.666L44.1227 38.9112C44.6059 38.9149 44.9947 39.3096 44.991 39.7929C44.9873 40.2761 44.5925 40.6648 44.1093 40.6611L12.1593 40.416C11.6761 40.4123 11.2873 40.0175 11.291 39.5343Z",
    fill: "#282D33"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0496 31.464C23.0695 30.9812 23.477 30.6059 23.9598 30.6258L23.9238 31.5C23.9598 30.6258 23.9603 30.6258 23.9607 30.6258L23.9616 30.6258L23.9636 30.6259L23.9685 30.6261L23.9812 30.6268L24.0187 30.6293C24.0489 30.6315 24.0892 30.6349 24.1385 30.6403C24.2367 30.651 24.3717 30.6694 24.5322 30.7011C24.8502 30.7638 25.285 30.8817 25.7387 31.1054C26.6712 31.5651 27.6843 32.4828 27.8818 34.177C27.9377 34.657 27.5939 35.0914 27.1139 35.1474C26.6339 35.2033 26.1995 34.8596 26.1435 34.3796C26.0305 33.4099 25.4992 32.9384 24.9649 32.675C24.6852 32.5371 24.406 32.4599 24.1934 32.418C24.0886 32.3973 24.0041 32.386 23.9492 32.38C23.9219 32.377 23.9022 32.3754 23.8915 32.3746L23.8827 32.374C23.4023 32.3515 23.0298 31.9451 23.0496 31.464Z",
    fill: "#282D33"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8543 32.2003C19.8742 31.7175 20.2817 31.3422 20.7645 31.3621L20.7285 32.2363C20.7645 31.3621 20.7649 31.3621 20.7654 31.3621L20.7663 31.3622L20.7683 31.3622L20.7731 31.3625L20.7859 31.3631L20.8234 31.3656C20.8535 31.3678 20.8939 31.3712 20.9432 31.3766C21.0414 31.3873 21.1763 31.4057 21.3369 31.4374C21.6549 31.5001 22.0897 31.618 22.5434 31.8417C23.4759 32.3015 24.489 33.2191 24.6864 34.9133C24.7424 35.3933 24.3986 35.8278 23.9186 35.8837C23.4386 35.9397 23.0042 35.5959 22.9482 35.1159C22.8352 34.1463 22.3039 33.6748 21.7696 33.4113C21.4899 33.2734 21.2107 33.1962 20.9981 33.1543C20.8933 33.1336 20.8088 33.1223 20.7539 33.1163C20.7266 33.1134 20.7069 33.1117 20.6962 33.111L20.6874 33.1104C20.207 33.0878 19.8345 32.6815 19.8543 32.2003Z",
    fill: "#282D33"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFund1);
export default __webpack_public_path__ + "static/media/fund1.c958c2be2969a772d4e2509026d58597.svg";
export { ForwardRef as ReactComponent };